var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header p-2"
  }, [_c('div', {
    staticClass: "form-row align-items-center"
  }, [_c('label', {
    staticClass: "col-4 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('shipment.consignee')))]), _c('div', {
    staticClass: "col-8 text-right"
  }, [_c('addressbook-select', {
    ref: "addressbookSelect",
    attrs: {
      "types": ['CONSIGNEE'],
      "editable": _vm.editable
    },
    on: {
      "input": _vm.selectedConsigneeChanged
    }
  })], 1)])]), _c('div', {
    staticClass: "card-body p-2"
  }, [_vm.value == null ? _c('div', [_vm._v(" Keine Adresse ausgewählt. ")]) : _c('div', [_c('validation-observer', {
    ref: "observer",
    attrs: {
      "vid": "consignee_observer",
      "slim": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var invalid = _ref.invalid,
            changed = _ref.changed,
            dirty = _ref.dirty;
        return [_c('div', {
          staticClass: "form-row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('label', {
          attrs: {
            "for": "consignee-name"
          }
        }, [_vm._v(_vm._s(_vm.$t('address.address-data')))])])]), _c('div', {
          staticClass: "form-row"
        }, [_c('div', {
          staticClass: "col-7"
        }, [_c('e-form-text-input', {
          attrs: {
            "id": _vm.id + '-consignee.name',
            "name": "name",
            "rules": "required",
            "maxlength": "35",
            "placeholder": _vm.$t('address.name'),
            "disabled": !(_vm.editable && _vm.isAddressDataEditable)
          },
          model: {
            value: _vm.value.name,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "name", $$v);
            },
            expression: "value.name"
          }
        })], 1), _c('div', {
          staticClass: "col-5"
        }, [_c('e-form-text-input', {
          attrs: {
            "id": _vm.id + '-consignee.customerId',
            "name": "customerId",
            "maxlength": "35",
            "placeholder": _vm.$t('address.customerId'),
            "disabled": !(_vm.editable && _vm.isAddressDataEditable)
          },
          model: {
            value: _vm.value.customerId,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "customerId", $$v);
            },
            expression: "value.customerId"
          }
        })], 1)]), _c('div', {
          staticClass: "form-row"
        }, [_c('div', {
          staticClass: "col-7"
        }, [_c('e-form-text-input', {
          attrs: {
            "id": _vm.id + '-consignee.additionalName',
            "name": "additionalName",
            "maxlength": "35",
            "placeholder": _vm.$t('address.additionalName'),
            "disabled": !(_vm.editable && _vm.isAddressDataEditable)
          },
          model: {
            value: _vm.value.additionalName,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "additionalName", $$v);
            },
            expression: "value.additionalName"
          }
        })], 1), _c('div', {
          staticClass: "col-5"
        }, [_c('e-form-checkbox', {
          attrs: {
            "id": _vm.id + '-consigneee.isRetail',
            "name": "isRetail",
            "placeholder": _vm.$t('shipment.consignee.isRetail'),
            "disabled": !(_vm.editable && _vm.isAddressDataEditable)
          },
          model: {
            value: _vm.value.isRetail,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "isRetail", $$v);
            },
            expression: "value.isRetail"
          }
        }), _c('e-form-checkbox', {
          attrs: {
            "id": _vm.id + '-consigneee.isBusiness',
            "name": "isBusiness",
            "placeholder": _vm.$t('shipment.consignee.isBusiness'),
            "disabled": !(_vm.editable && _vm.isAddressDataEditable),
            "value": !_vm.value.isRetail
          },
          on: {
            "input": function input($event) {
              _vm.value.isRetail = !$event;
            }
          }
        })], 1)]), _c('div', {
          staticClass: "form-row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('e-form-text-input', {
          attrs: {
            "id": _vm.id + '-consignee.street',
            "name": "street",
            "rules": "required",
            "maxlength": "35",
            "placeholder": _vm.$t('address.streetWithNumber'),
            "disabled": !(_vm.editable && _vm.isAddressDataEditable)
          },
          model: {
            value: _vm.value.street,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "street", $$v);
            },
            expression: "value.street"
          }
        })], 1)]), _c('div', {
          staticClass: "form-row"
        }, [_c('div', {
          staticClass: "col-3"
        }, [_c('country-select', {
          attrs: {
            "id": _vm.id + '-consignee.country',
            "name": "country",
            "required": true,
            "placeholder": _vm.$t('address.country'),
            "disabled": !(_vm.editable && _vm.isAddressDataEditable)
          },
          model: {
            value: _vm.value.country,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "country", $$v);
            },
            expression: "value.country"
          }
        })], 1), _c('div', {
          staticClass: "col-3"
        }, [_c('e-form-text-input', {
          attrs: {
            "id": _vm.id + '-consignee.zipCode',
            "name": "zipCode",
            "rules": {
              required: true,
              zipCode: {
                country: '@' + _vm.id + '-consignee.country'
              }
            },
            "placeholder": _vm.$t('address.zipCode'),
            "disabled": !(_vm.editable && _vm.isAddressDataEditable)
          },
          on: {
            "blur": function blur($event) {
              return _vm.formatZipCode($event);
            }
          },
          model: {
            value: _vm.value.zipCode,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "zipCode", $$v);
            },
            expression: "value.zipCode"
          }
        })], 1), _c('div', {
          staticClass: "col-6"
        }, [_c('city-select', {
          attrs: {
            "id": _vm.id + '-consignee.city',
            "rules": "required",
            "disabled": !(_vm.editable && _vm.isAddressDataEditable),
            "country": _vm.value.country,
            "zip-code": _vm.value.zipCode
          },
          on: {
            "citySelect": _vm.onCitySelect
          },
          model: {
            value: _vm.value.city,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "city", $$v);
            },
            expression: "value.city"
          }
        })], 1)]), _c('div', {
          staticClass: "form-row"
        }, [_vm.editable && !_vm.isAddressDataEditable ? _c('div', {
          staticClass: "col-12 pb-2"
        }, [_c('em', [_vm._v(" " + _vm._s(_vm.$t('address.only-contact-data-editable')) + " " + _vm._s(_vm.$t('address.contact-support-for-changing-administrative-data')) + " ")])]) : _vm._e()]), _c('div', {
          staticClass: "form-row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('label', {
          attrs: {
            "for": "consignee-contact-name"
          }
        }, [_vm._v(_vm._s(_vm.$t('address.contact-data')))])])]), _c('div', {
          staticClass: "form-row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('e-form-text-input', {
          attrs: {
            "id": _vm.id + '-consignee.contactName',
            "name": "contactName",
            "placeholder": _vm.$t('address.consignee.contactName'),
            "maxlength": "255",
            "disabled": !_vm.editable
          },
          model: {
            value: _vm.value.contactName,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "contactName", $$v);
            },
            expression: "value.contactName"
          }
        })], 1)]), _c('div', {
          staticClass: "form-row"
        }, [_c('div', {
          staticClass: "col-6"
        }, [_c('e-form-text-input', {
          attrs: {
            "id": _vm.id + '-consignee.mobile',
            "name": "mobile",
            "rules": "phoneNumber:MOBILE",
            "placeholder": _vm.$t('address.mobile'),
            "disabled": !_vm.editable
          },
          model: {
            value: _vm.value.mobile,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "mobile", $$v);
            },
            expression: "value.mobile"
          }
        })], 1), _c('div', {
          staticClass: "col-6"
        }, [_c('e-form-text-input', {
          attrs: {
            "id": _vm.id + '-consignee.email',
            "name": "email",
            "rules": "email",
            "placeholder": _vm.$t('address.email'),
            "disabled": !_vm.editable
          },
          model: {
            value: _vm.value.email,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "email", $$v);
            },
            expression: "value.email"
          }
        })], 1)]), _c('div', {
          staticClass: "form-row"
        }, [_c('div', {
          staticClass: "col-6"
        }, [_c('e-form-text-input', {
          attrs: {
            "id": _vm.id + '-consignee.phone',
            "name": "phone",
            "rules": "phoneNumber",
            "placeholder": _vm.$t('address.phone'),
            "disabled": !_vm.editable
          },
          model: {
            value: _vm.value.phone,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "phone", $$v);
            },
            expression: "value.phone"
          }
        })], 1), _c('div', {
          staticClass: "col-6"
        }, [_c('e-form-text-input', {
          attrs: {
            "id": _vm.id + '-consignee.web',
            "name": "web",
            "maxlength": "70",
            "placeholder": _vm.$t('address.url'),
            "disabled": !_vm.editable
          },
          model: {
            value: _vm.value.web,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "web", $$v);
            },
            expression: "value.web"
          }
        })], 1)]), _c('div', {
          staticClass: "form-row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_vm._t("default")], 2)]), _c('div', {
          staticClass: "form-row"
        }, [_c('div', {
          staticClass: "col-12 text-right"
        }, [_c('button', {
          staticClass: "btn btn-link",
          attrs: {
            "disabled": !_vm.editable || !(changed || dirty || _vm.value._links)
          },
          on: {
            "click": _vm.createNewConsignee
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('address.reset-addressbook-entry')))])]), _vm.editable ? _c('button', {
          staticClass: "btn btn-link",
          attrs: {
            "disabled": !(changed || dirty) || invalid
          },
          on: {
            "click": _vm.saveConsignee
          }
        }, [_vm._v(" " + _vm._s(_vm.value._links ? _vm.$t('address.update-addressbook-entry') : _vm.$t('address.create-addressbook-entry')) + " ")]) : _vm._e()])])];
      }
    }], null, true)
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }